import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function BonusGrid() {
  const bonuses = [{
    id: 1,
    title: 'Guía de Marketing para Vender',
    image: 'https://cdn.magicpatterns.com/uploads/7mu24rk948ds1j8kpWPExD/Captura_de_pantalla_2026-03-25_153752.png',
    originalPrice: '$12.990'
  }, {
    id: 2,
    title: 'Decoración Moderna e Iluminación',
    image: 'https://cdn.magicpatterns.com/uploads/wgHiN7aeoAdmxtKmrcz2G8/decoracion.webp',
    originalPrice: '$12.990'
  }, {
    id: 3,
    title: 'Precios, Costos y Ventas',
    image: 'https://cdn.magicpatterns.com/uploads/qXMECcj9NkgeYFBaiRrXrD/costos.webp',
    originalPrice: '$12.990'
  }, {
    id: 4,
    title: 'Diseños y Trabajo Profesional con Luces LED',
    image: 'https://cdn.magicpatterns.com/uploads/wm6XoazqL2ndD4QeTffvWy/luces_led.webp',
    originalPrice: '$14.990'
  }, {
    id: 5,
    title: 'Taller de Madera - Diseño sin Límites',
    image: 'https://cdn.magicpatterns.com/uploads/4UQzw9rRd7mvJqvw92GwnL/book_5.jpg',
    originalPrice: '$14.990'
  }];
  // Calculate total value
  const totalValue = bonuses.reduce((sum, bonus) => {
    const price = parseInt(bonus.originalPrice.replace(/[$.]/g, ''));
    return sum + price;
  }, 0);
  return <section className="py-24 px-4 relative z-10 bg-[#0a0514] overflow-hidden border-y border-[#27272a] pt-[40px] pb-[40px]" data-id="element-22">
      <div className="max-w-7xl mx-auto" data-id="element-23">
        <div className="text-center mb-16" data-id="element-24">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#130a2a] border border-[#27272a] text-[#f5c518] text-sm font-bold mb-6 tracking-wide" data-id="element-25">
            🎁 OFERTA POR TIEMPO LIMITADO
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white mb-6 tracking-tight leading-[1.1]" data-id="element-26">
            BONUS EXCLUSIVOS
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-gray-400 max-w-2xl mx-auto font-normal mb-4" data-id="element-27">
            Llevate estos 5 ebooks GRATIS con tu compra de hoy
          </motion.p>
        </div>

        {/* Bonus Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-28">
          {bonuses.map((bonus, index) => <motion.div key={bonus.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-[#130a2a] border border-[#27272a] rounded-3xl p-6 hover:border-[#3f3f46] transition-all duration-300 hover:shadow-[0_20px_60px_rgba(0,240,255,0.1)] group" data-id="element-29">
              {/* Bonus Badge */}
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#f5c518]/10 border border-[#f5c518]/30 text-[#f5c518] text-xs font-bold mb-4 tracking-wider" data-id="element-30">
                BONUS {bonus.id}
              </div>

              {/* Book Image */}
              <div className="relative mb-6 overflow-hidden rounded-2xl group-hover:scale-105 transition-transform duration-300" data-id="element-31">
                <img src={bonus.image} alt={bonus.title} width={400} height={400} loading="lazy" decoding="async" className="w-full h-auto object-cover" data-id="element-32" />
              </div>

              {/* Pricing */}
              <div className="text-center" data-id="element-33">
                <p className="text-gray-500 text-sm font-medium mb-2" data-id="element-34">
                  VALOR NORMAL:
                </p>
                <p className="text-2xl text-gray-600 line-through font-bold decoration-red-500/60 decoration-4 mb-3" data-id="element-35">
                  {bonus.originalPrice} ARS
                </p>
                <div className="bg-gradient-to-r from-[#f5c518] to-[#d97706] text-black font-black text-xl py-3 px-6 rounded-xl uppercase tracking-wide" data-id="element-36">
                  GRATIS HOY
                </div>
              </div>
            </motion.div>)}

          {/* Empty space for centering on large screens */}
          <div className="hidden lg:block" data-id="element-37"></div>
        </div>
      </div>
    </section>;
}